import React, { useState, useEffect, useRef } from 'react';
import Technologies from '../technologies/technologies';
import styles from "./overview.module.scss";

const Overview = () => {
    const [typedText, setTypedText] = useState('');
    const fullText = 'Summary.';
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    let index = 0;
                    const typingInterval = setInterval(() => {
                        if (index < fullText.length) {
                            setTypedText(fullText.slice(0, index + 1));
                            index++;
                        } else {
                            clearInterval(typingInterval);
                        }
                    }, 150);
                }
            },
            { threshold: 0.5 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    return (
        <section id="overview" ref={sectionRef} className={`p-5 md:p-16 lg:p-20 ` + styles.overview}>
            <div className={`flex xl:flex-row flex-col-reverse gap-10 justify-left overflow-hidden`}>
                <div className={`flex-[0.6] p-5 rounded-2xl`}>
                    <h2 className={`main_color ${styles.typing}`}>{typedText}</h2>
                    <div className={`text-lg text-justify`}>
                        Hi, I’m Mansi Patil, a passionate Software Engineer and Full-Stack Developer who thrives on building meaningful, user-focused applications. Whether it’s boosting engagement for e-commerce platforms or simplifying event planning through intuitive design, I love solving real-world problems with clean, scalable code.
                        I enjoy both building from scratch and refining existing features. I approach every challenge with curiosity, creativity, and a commitment to continuous improvement. To me, great software comes from thoughtful design, clear communication, and code that’s built to last.
                    </div>
                </div>
            </div>
            <Technologies />
        </section>
    );
};

export default Overview;